import * as React from 'react';
import classnames from 'classnames';
import { camelCase } from 'lodash';

import DeliverableTagPill from 'components/deliverable-tag-pill/DeliverableTagPill';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import { DELIVERABLE_ICONS } from 'utils/deliverables';

import type { Deliverable } from 'types';

import './deliverable-header-v2.scss';

type Props = {
  deliverable: Pick<Deliverable, 'id' | 'deliverableType' | 'name' | 'tag'>,
  mode?: 'create' | 'view',
  isExpanded?: boolean,
  onExpanded?: () => void
};

const DeliverableHeader = ({ deliverable, mode = 'create', isExpanded, onExpanded }: Props) => {
  const renderType = (): React.ReactNode => {
    const { deliverableType } = deliverable;

    return (
      <SVGDynamicIcon
        name={`${DELIVERABLE_ICONS[camelCase(deliverableType)]}`}
        height={21}
        width={21}
        customColor="black"
      />
    );
  };

  const renderTitle = (): React.ReactNode => (
    <Tooltip
      message={deliverable.name}
      display="flex"
    >
      <div
        className="deliverable-header-v2__title text-overflow-ellipsis"
      >
        {deliverable.name}
      </div>
    </Tooltip>
  );

  const renderTag = (): React.ReactNode => {
    const tag = deliverable.tag;

    if (!tag || !tag.name || !tag.color) {
      return null;
    }

    return (
      <div className="deliverable-header-v2__tag">
        <DeliverableTagPill
          name={tag.name}
          color={tag.color}
          wide="long"
        />
      </div>
    );
  };

  const expandElClasses = classnames('deliverable-header-v2__expand', {
    'deliverable-header-v2__expand--expanded': isExpanded
  });

  return (
    <div className="deliverable-header-v2">
      <div className="deliverable-header-v2__container">
        {renderType()}
        <div className="deliverable-header-v2__title-container">
          <div className="deliverable-header-v2__title-info">
            {renderTitle()}
            {renderTag()}
          </div>
        </div>
        {
          mode === 'view' && (
            <div className={expandElClasses}>
              <SVGDynamicIcon
                name="chevron-down-custom-fg"
                height={15}
                width={15}
                customColor="black"
                clickable
                onClick={() => {
                  if (onExpanded) {
                    onExpanded();
                  }
                }}
              />
            </div>
          )
        }
      </div>
    </div>
  );
};

export default DeliverableHeader;
